import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'nominas/periodos-de-seguro-issste/';
export const baseURI2 = 'catalogos/catalogo-de-concepto-periodicidad-de-seguridad-social';

/**
 * GET Periodos de Pago del ISSSTE
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPeriodosPagoISSSTE = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Periodo de Pago del ISSSTE
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPeriodoPagoISSSTE = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Periodo de Pago del ISSSTE
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPeriodoPagoISSSTE = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Periodo de Pago del ISSSTE
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPeriodoPagoISSSTE = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}/`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Periodo de Pago del ISSSTE
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePeriodoPagoISSSTE = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Periodo de Pago del ISSSTE
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarPeriodoPagoISSSTE = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}/`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Conceptos - Periodicidad de Seguridad Social
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getConceptosPeriodosPagoSS = async (params) => {
  try {
    const response = await API.get(baseURI2, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
